const getPluginCountryCode = () => {
  // preview mode (for iframe deployments i.e bulk pickup)
  const queryParams = new URLSearchParams(window.location.search);
  const queryParamCountryCode = queryParams.get('country_cd');

  // script deployments
  const attributeCountryCode = document.getElementById(process.env.REACT_APP_ROOT_ID).getAttribute('rc-country-cd');
  return queryParamCountryCode || attributeCountryCode;
};

export default getPluginCountryCode;
